import React, { useState, useEffect } from 'react';
//import algoliasearch from 'algoliasearch/lite';
import { onSetModuleId, useGlobalModuleId, onSetActiveModuleId, onSetActiveIndicator } from '../../data/StatusStore';
import { liteClient } from 'algoliasearch/lite';

const client = liteClient('YOUR_APP_ID', 'YOUR_API_KEY');
// Algolia Setup
// csee@uwalumni.com account
const ALGOLIA_APP_ID = '2PIZZWD1JO';  // Replace with your Algolia App ID
const ALGOLIA_SEARCH_KEY = 'cc5a6896f462e03c3677f4af6973c2a2'; // Replace with your Search API Key
const ALGOLIA_INDEX_NAME = 'searchData'; // Replace with your Algolia index name
/*
Application ID:
2PIZZWD1JO
Search API Key:
cc5a6896f462e03c3677f4af6973c2a2
Write API Key:
35a6d78c9db8bf30cc157768551f5a69
*/

// ✅ Create Search Client
const searchClient = liteClient(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);

const SearchPopup = ({
  isOpen,
  onClose,
  searchData,
  groupedModules,
  allData,
  setModuleIdIncrement,
  moduleIdIncrement,
}: {
  isOpen: boolean;
  onClose: () => void;
  searchData: any | null;
  groupedModules: any | null;
  allData: any | null;
  setModuleIdIncrement: Function;
  moduleIdIncrement: number;
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredResults, setFilteredResults] = useState<any[]>([]);
  const moduleId = useGlobalModuleId();

  // ✅ Perform Search Using Algolia
  useEffect(() => {
    if (searchTerm.length > 2) {
      searchClient
        .search([{ indexName: ALGOLIA_INDEX_NAME, params: { query: searchTerm } }])
        .then(({ results }) => {
          setFilteredResults((results[0] as any).hits);
        })
        .catch((err) => console.error('Algolia Search Error:', err));
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleSelect = (item: any) => {
    console.log(`Selected: ${item.search}`);
    onSetModuleId(item.directive_data);
    onSetActiveIndicator(item.data,"algolia search", "N/A");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{ position: 'fixed', top: '50px', left: 250, width: '100vw', height: 'calc(100% - 50px)', backgroundColor: '#fff', zIndex: 1001 }}>
      <div style={{ position: 'absolute', top: '20px', right: '20px', cursor: 'pointer', fontSize: '24px' }} onClick={onClose}>
        X
      </div>
      <div style={{ textAlign: 'left', width: '80%', maxWidth: '600px' }}>
        <div style={{ position: 'relative', width: '100%', marginBottom: '20px' }}>
          <input type="text" value={searchTerm} onChange={handleInputChange} placeholder="Search..." style={{ width: '100%', padding: '10px', fontSize: '2rem', border: 'none', borderBottom: '2px solid #333', outline: 'none', textAlign: 'left', color: '#666' }} />
        </div>

        <ul style={{ listStyleType: 'none', padding: 0, margin: 0, width: '100%', maxHeight: '200px', overflowY: 'auto', textAlign: 'left' }}>
          {filteredResults.length > 0 ? (
            filteredResults.map((item) => (
              <li key={item.objectID} style={{ padding: '10px', cursor: 'pointer', backgroundColor: '#f5f5f5', marginBottom: '5px' }} onClick={() => handleSelect(item)}>
                {item.search}
              </li>
            ))
          ) : (
            <li style={{ padding: '10px', fontStyle: 'italic' }}>No results found</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default SearchPopup;